import { buildAuthFunctions } from '@js/core/auth/helpers.js';

const authFunctions = buildAuthFunctions('invoices');

export default {
    unlock: authFunctions.manage,
    lock: authFunctions.manage,
    send: authFunctions.manage,
    ...authFunctions,
};